import { SelectedProposal } from '../model/types/ProposalSchema';

/**
 * Calculates quantities for a selected proposal.
 * If approvedQuantity is null, supplier hasn't responded yet - treat as approved (use selectedQuantity).
 *
 * @param proposal - The selected proposal to calculate quantities for
 * @returns Object containing selectedQty, approvedQty, and unavailableQty
 */
export const getProposalQuantities = (
    proposal: SelectedProposal | undefined,
): {
    selectedQty: number;
    approvedQty: number;
    unavailableQty: number;
} => {
    const selectedQty = proposal?.selectedQuantity ?? 0;
    const approvedQty = proposal?.approvedQuantity ?? selectedQty;
    const unavailableQty = Math.max(0, selectedQty - approvedQty);

    return {
        selectedQty,
        approvedQty,
        unavailableQty,
    };
};
